export enum ETermsOfService {
  TermsOfUse = 'https://justsext.com/tos',
  Privacy = 'https://justsext.com/privacy',
  PaymentPolicy = 'https://justsext.com/payment-policy',
  ContentRemovalPolicy = 'https://justsext.com/content-removal',
  ComplaintsPolicy = 'https://justsext.com/complaints-policy',
  HelpCenter = 'https://airtable.com/appxBO8pYpQMldSMV/pagoUYCJBBdTcDJgm/form',
  ComplianceNotice = 'https://stxt.notion.site/18-U-S-C-2257-Compliance-Notice-7d7d72e8acc943129a04cafca2bfd21c'
}

export enum ERecaptchaTermsLinks {
  PrivacyPolicy = 'https://policies.google.com/privacy',
  TermsOfService = 'https://policies.google.com/terms'
}
